import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Login from '../components/Login'
import actions from './../actions';
import React, { Component } from "react";
import Validators from './../../shared/utils/Validators';
import _ from '../../shared/utils/ObjectUtils';
import { I18n } from 'react-redux-i18n';
import ForgotPasswordContainer from './ForgotPasswordContainer';
import ResetPasswordContainer from './ResetPasswordContainer';
import { Redirect } from 'react-router-dom';
import Alert from './../../shared/components/alerts/Alert';
import { fetchTheme } from "../../shared/style/MUIThemes";
import { MuiThemeProvider } from '@material-ui/core/styles';

class LoginContainer extends Component {
    constructor() {
        super();
        this.state = {
            userFormData: {
                email: {
                    value: '',
                    error: null
                },
                password: {
                    value: '',
                    error: null
                }
            },
            alert: {
                show: false
            }
        }
    }

    /* Hack for Chrome mobile that does not trigger 'change' event on autofill */
    /*componentDidMount() {
      const inputs = this.formRef.getElementsByTagName('input');
      this.interval = setInterval(function () {
        _.forEach(inputs, (i) => {
          let e = {};
          e.target = { name: i.name, value: i.value };
          this.onChange(e);
        })
      }.bind(this), 500);
    }*/

    validateField = key => {
        const { userFormData } = this.state;
        const value = userFormData[key].value;
        let error = null;

        switch (key) {
            case "email":
                error = Validators.email(value) ? null : I18n.t('auth.errors.invalidEmail');
                break;
            case "password":
                error = Validators.passwordLength(value) ? I18n.t('auth.errors.invalidPasswordLength', { charCount: "6" }) : null;
                break;
            default:
                break;
        }

        userFormData[key].error = error;
        this.setState({ userFormData });
    };

    componentWillMount() {
        const {
            location: {
                pathname: location
            },
            collapseResetPasswordForm
        } = this.props;
        if (location.includes('reset')) {
            collapseResetPasswordForm(true);
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            loadingResetPasswordRequest: currentLoadingReset,
            loadingForgotPasswordRequest: currentLoadingForgot,
        } = this.props;

        const {
            loadingResetPasswordRequest: nextLoadingReset,
            loadingForgotPasswordRequest: nextLoadingForgot,
            resetPasswordError,
            forgotPasswordError
        } = nextProps;


        if (currentLoadingReset && !nextLoadingReset) {
            if (_.isUndefined(resetPasswordError)) {
                this.handleResetOrForgotSuccess('reset');
            } else {
                this.handleResetOrForgotError('reset', resetPasswordError);
            }
        } else if (currentLoadingForgot && !nextLoadingForgot) {
            if (_.isUndefined(forgotPasswordError)) {
                this.handleResetOrForgotSuccess('forgot');
            } else {
                this.handleResetOrForgotError('forgot', forgotPasswordError);
            }
        }
    };

    handleResetOrForgotSuccess = successKey => {
        this.setState({
            alert: {
                show: true,
                type: successKey === 'forgot' ? 'info' : 'success',
                title: I18n.t('auth.alerts.' + successKey + '.success.title'),
                html: I18n.t('auth.alerts.' + successKey + '.success.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.hideAlert,
                onConfirm: this.hideAlert
            }
        })
    };

    handleResetOrForgotError = (errorKey, error) => {
        this.setState({
            alert: {
                show: true,
                /*      type: 'error', */
                type: "info",
                title: I18n.t('auth.alerts.' + errorKey + '.error.title'),
                html: error,
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        });
    };


    handleFormDataChange = (value, key) => {
        const { userFormData } = this.state;
        userFormData[key].value = value;
        this.setState({ userFormData });
        if (userFormData[key].error) {
            this.validateField(key);
        }
    };

    handleLoginClicked = () => {
        const { userFormData } = this.state;
        const { login } = this.props;

        let loginIsValid = Object.values(userFormData)
            .reduce((acc, field) => acc && _.isNilOrEmpty(field.error), true);

        //add errors   

        if (loginIsValid) {
            login(userFormData);
        } else {
            this.setState({ userFormData });
        }
    };

    handleForgotPasswordButtonClicked = (status) => {
        this.props.collapseForgotPasswordForm(status);
    };

    handleResetPasswordButtonClicked = (status) => {
        this.props.collapseResetPasswordForm(status);
    };

    render() {
        const { userFormData, alert } = this.state;
        let {
            userLoggedIn,
            location,

            showResetPasswordForm,
            loadingResetPasswordRequest,

            showForgotPasswordForm,
            loadingForgotPasswordRequest
        } = this.props;

        if (userLoggedIn) {
            return <Redirect to="/dashboard" />
        }

        return (
            <MuiThemeProvider theme={fetchTheme("default")} >
                <div className="container no-max-height no-max-width fill">
                    <div className="row no-max-height fill">
                        <Alert
                            {...alert}
                            loading={loadingForgotPasswordRequest || loadingResetPasswordRequest}
                        />
                        {showResetPasswordForm && (
                            <ResetPasswordContainer
                                url={location.pathname}
                                className="col-xl-3 col-lg-4 col-md-6 col-xs-10 forgot-password-container inherit-height"
                                handleResetPasswordButtonClicked={() => this.handleResetPasswordButtonClicked(false)}
                            />
                        )}
                        <div className={showForgotPasswordForm || showResetPasswordForm ? 'col-xl-9 col-lg-8 col-md-6 d-none d-lg-block' : 'col-12'}>
                            <Login
                                {...this.props}
                                formIsNotFilledOrError={!userFormData.email.value || !userFormData.password.value || userFormData.email.error || userFormData.password.error}
                                userFormData={userFormData}
                                login={this.handleLoginClicked}
                                handleFieldBlur={this.validateField}
                                handleFormDataChanged={this.handleFormDataChange}
                                handleForgotPasswordButtonClicked={this.handleForgotPasswordButtonClicked}
                                handleResetPasswordButtonClicked={this.handleResetPasswordButtonClicked}
                                disabled={showForgotPasswordForm || showResetPasswordForm}
                            />
                        </div>
                        {showForgotPasswordForm && (
                            <ForgotPasswordContainer
                                className="col-xl-3 col-lg-4 col-md-6 col-sm-12 forgot-password-container inherit-height"
                                handleCollapseForgotPasswordClicked={() => this.handleForgotPasswordButtonClicked(false)}
                            />
                        )}
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

LoginContainer.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string,
    }),
    userLoggedIn: PropTypes.bool.isRequired,
    loginError: PropTypes.string,
    login: PropTypes.func.isRequired
};

const mapStateToProps = ({ authReducer }) => ({
    loginError: authReducer.loginError,
    userLoggedIn: authReducer.userLoggedIn,
    user: authReducer.user,
    loadingLoginRequest: authReducer.loadingLoginRequest,

    showResetPasswordForm: authReducer.showResetPasswordForm,
    loadingResetPasswordRequest: authReducer.loadingResetPasswordRequest,
    resetPasswordError: authReducer.resetPasswordError,

    showForgotPasswordForm: authReducer.showForgotPasswordForm,
    loadingForgotPasswordRequest: authReducer.loadingForgotPasswordRequest,
    forgotPasswordError: authReducer.forgotPasswordError
});

const mapDispatchToProps = {
    login: actions.login,
    logout: actions.logout,
    collapseForgotPasswordForm: actions.collapseForgotPasswordForm,
    collapseResetPasswordForm: actions.collapseResetPasswordForm
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginContainer)